// extracted by mini-css-extract-plugin
export default {"formCheck":"FormCheck_formCheck__UiPJ5"};